import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { IAppeal, IResidence } from 'types/api/residences';

interface IApplicationWinner {
  residence: IResidence;
  appeal: IAppeal;
}
const ApplicationWinner: React.FC<IApplicationWinner> = ({ residence, appeal }) => {
  const { t } = useTranslation();
  return (
    <div className="animate-fade-in-up flex flex-col items-center gap-4  mt-16 shadow border bg-white rounded p-4">
      <h1 className="bg-green-500 px-4 py-2 text-white rounded-full font-bold text-3xl text-center">
        {t('ApplicationWinner.title')}
      </h1>
      <h2 className="text-black font-bold text-xl text-center">{t('ApplicationWinner.description1')}</h2>
      <h3 className="text-green-600 font-bold text-xl text-center">{t('ApplicationWinner.description2')}</h3>
      <h4 className="text-bluemazza font-bold text-lg text-center">
        {residence.name} - {dayjs(appeal.date).format('DD/MM/YYYY')}
      </h4>
      <h3 className="text-bluemazza font-medium text-lg underline text-center">
        {t('ApplicationWinner.description3')}
      </h3>
    </div>
  );
};
export default ApplicationWinner;
